import { Center, Loader, Stack } from "@mantine/core";

interface LoadingFallbackProps {
	size?: "xs" | "sm" | "md" | "lg" | "xl";
	fullHeight?: boolean;
}

export function LoadingFallback({
	size = "md",
	fullHeight = false,
}: LoadingFallbackProps) {
	return (
		<Stack h={fullHeight ? "100dvh" : "100%"}>
			<Center h="100%">
				<Loader size={size} />
			</Center>
		</Stack>
	);
}
